import { render, staticRenderFns } from "./blockSettingsNavigation.vue?vue&type=template&id=92e1b442&scoped=true&"
import script from "./blockSettingsNavigation.vue?vue&type=script&lang=js&"
export * from "./blockSettingsNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e1b442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VIcon,VSheet})
